import { useParams, Navigate } from "react-router-dom";
import { Language } from "./context";

const NotFoundRedirect = () => {
  const { lang } = useParams();

  const validLangs = Object.values(Language).filter((v) => v != Language.LANG);

  if (validLangs.includes(lang)) {
    return <Navigate to={`/${lang}`} replace />;
  } else {
    return <Navigate to="/kr" replace />;
  }
};

export default NotFoundRedirect;
